import BarChartIcon from '@mui/icons-material/BarChart';

import classes from './SideMenuLiftDetail.module.scss';

import { $api } from '~/lib/api-client';
import { skipToken, useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

const SideMenuLiftDetail = () => {
  const { liftID } = useParams();
  const liftId = liftID ? Number(liftID) : null;

  const liftByIdQuery = useQuery({
    queryKey: ['lift', liftId],
    queryFn: liftId
      ? async () => {
          const { data } = await $api['/liftstatus/lift/{id}'].GET({
            params: { path: { id: liftId } },
          });

          if (!data) {
            throw new Error(`Lift not found for id: ${liftId}`);
          }

          return data;
        }
      : skipToken,
  });

  if (!liftId || !liftByIdQuery.data) {
    return null;
  }

  return (
    <div className={classes.liftData}>
      <p>
        <b>{liftId}</b> -{' '}
        {liftByIdQuery.data.details.liftname
          ? liftByIdQuery.data?.details.liftname
          : 'Lift'}
      </p>
      <span className={classes.liftLocation}>
        <BarChartIcon className={classes.liftLocationIcon} />
        <p>{liftByIdQuery.data?.details?.address}</p>
      </span>
    </div>
  );
};

export default SideMenuLiftDetail;
